import React from "react";
import PolicyPageTemplate from "../../components/common/PolicyPageTemplate";
import { FileText } from "lucide-react";

const SECTIONS = [
  {
    number: "1",
    title: "Acceptance of Terms",
    body: "By downloading, accessing, or using the AAFSA application, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions. If you do not agree to these terms, please discontinue use of the application immediately.",
  },
  {
    number: "2",
    title: "Donations",
    body: "All donations made through the platform are voluntary and non-refundable unless specifically authorised by the organisation in writing. AAFSA ensures that 100% of directed donations reach the intended cause. Donation receipts are issued electronically for tax-deduction purposes.",
  },
  {
    number: "3",
    title: "User Accounts & Eligibility",
    body: "You must be at least 18 years of age to create an account and make donations. You are responsible for maintaining the confidentiality of your account credentials. Any activity conducted under your account is your sole responsibility. AAFSA reserves the right to suspend or terminate accounts that violate these terms.",
  },
  {
    number: "4",
    title: "User Conduct",
    body: "Users are expected to engage respectfully with the community at all times. The following activities are strictly prohibited: abusive or harassing behaviour, spamming, misrepresentation of identity, fraudulent donation activity, and any attempt to circumvent platform security. Violations will result in immediate account termination.",
  },
  {
    number: "5",
    title: "Intellectual Property",
    body: "All content within this application — including logos, imagery, text, and software — is the exclusive intellectual property of AAFSA. Reproduction, distribution, or modification of any content without prior written consent is strictly prohibited.",
  },
  {
    number: "6",
    title: "Third-Party Services",
    body: "AAFSA may utilise third-party payment processors and service providers to facilitate transactions. By using the application, you agree to the respective terms and privacy policies of these third-party services. AAFSA is not responsible for the actions or policies of third-party providers.",
  },
  {
    number: "7",
    title: "Limitation of Liability",
    body: "AAFSA shall not be liable for any indirect, incidental, or consequential damages arising from your use of the application, including but not limited to loss of data, service interruptions, or technical errors. Your use of the platform is at your own risk.",
  },
  {
    number: "8",
    title: "Modifications to Terms",
    body: "AAFSA reserves the right to update or amend these Terms & Conditions at any time. Users will be notified of material changes via in-app notice or email. Continued use of the application following notification constitutes acceptance of the revised terms.",
  },
  {
    number: "9",
    title: "Governing Law",
    body: "These Terms & Conditions are governed by and construed in accordance with the laws of the applicable jurisdiction. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in that region.",
  },
  {
    number: "10",
    title: "Contact Us",
    body: "If you have any questions or concerns regarding these Terms & Conditions, please contact us at legal@aafsa.org or write to us at our registered office address.",
  },
];

const TermsConditions = () => {
  return (
    <PolicyPageTemplate
      title="Terms & Conditions"
      subtitle="Please read these terms and conditions carefully before using our platform, contributing donations, or participating in AAFSA initiatives."
      dateLabel="EFFECTIVE DATE"
      dateValue="1 January 2025"
      contactEmail="legal@aafsa.org"
      contactRole="Legal & Compliance Department"
      intro="Welcome to AAFSA. By using this application you agree to comply with and be bound by the following Terms & Conditions. Please read them carefully before proceeding."
      sections={SECTIONS}
      policyIcon={FileText}
    />
  );
};

export default TermsConditions;
